exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".pdf-viewer{overflow:hidden}.pdf-viewer>div{margin:0;border:none;height:calc(89vh - 140px);width:800px;max-width:calc(100vw - 40px)}", ""]);

